// src/utils/context/get-user-id/get-user-id.ts
async function getUserId() {
  let userId = null;
  if (window.yvaDatastore?.config.providers?.userIdProvider) {
    try {
      userId = await window.yvaDatastore.config.providers.userIdProvider();
    } catch (error) {
      if (window.yvaDatastore.config.debug) {
        console.error("Error getting user id");
        console.dir(error, { depth: null });
      }
    }
  }
  return userId;
}

export {
  getUserId
};
